import { ObjectPool } from './internal/objectPool';
var ComponentPool = /** @class */ (function () {
    function ComponentPool(Type, game) {
        var _this = this;
        this.Type = Type;
        this.game = game;
        this.pool = new ObjectPool(function () { return new _this.Type(); });
    }
    ComponentPool.prototype.acquire = function (initial, id) {
        if (initial === void 0) { initial = {}; }
        var instance = this.pool.acquire();
        this.Type.initialize(instance, initial, id);
        return instance;
    };
    ComponentPool.prototype.release = function (instance) {
        this.pool.release(instance);
    };
    Object.defineProperty(ComponentPool.prototype, "ComponentType", {
        get: function () {
            return this.Type;
        },
        enumerable: false,
        configurable: true
    });
    return ComponentPool;
}());
export { ComponentPool };
//# sourceMappingURL=ComponentPool.js.map